import { useT } from '../../i18n';

// ─────────────────────────────────────────────────────────────────────
// «A RESULT CAME IN FROM THE PAD» (#556).
//
// Shown only when the portal has a change it will NOT take on its own: one that
// touches a match somebody is typing into, or one it could not read well enough
// to be sure. Everything else is adopted silently and this never appears.
//
// IT OFFERS, IT DOES NOT COUNT DOWN. No timer, no auto-accept — the whole point
// is that the operator's unsent score survives until they decide. #537 is the
// precedent: an auto-refresh is exactly the thing that destroys the work.
// ─────────────────────────────────────────────────────────────────────

export interface PadResultWaitingBannerProps {
  /** Null when there is nothing waiting — the banner renders nothing. */
  pending: { changed: string[] } | null;
  onAccept: () => void;
}

export function PadResultWaitingBanner({ pending, onAccept }: PadResultWaitingBannerProps) {
  const t = useT();
  if (!pending) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-50 flex flex-wrap items-center gap-3 rounded-full border px-4 py-2 shadow-lg"
      style={{ bottom: '1.25rem', background: 'var(--paper)', borderColor: 'var(--line)' }}
      data-testid="pad-result-waiting"
      role="status"
    >
      <span className="text-xs">
        {t('padRefresh.waiting')} <span className="text-ink-3">{t('padRefresh.holding')}</span>
      </span>
      <button
        type="button"
        className="btn-lime text-[11px]"
        onClick={onAccept}
        data-testid="pad-result-waiting-accept"
      >
        {t('padRefresh.accept')}
      </button>
    </div>
  );
}
